<template>
  <Spin fix>
    <Icon type="load-c" size="35" class="demo-spin-icon-load"></Icon>
    <div class="loading-tips">Loading</div>
  </Spin>
</template>

<script>
export default {
  name: "DocumentLoading"
};
</script>

<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.loading-tips {
  font-size: medium;
}
</style>